import type { FinalResponse } from "./gateway";

export interface UnwrappedService<T> {
  found: boolean;
  status: number | null;
  payload: T | null;
  value: T | null;
}

export function isFinalResponse<T>(value: unknown): value is FinalResponse<T> {
  return (
    typeof value === "object" &&
    value !== null &&
    Array.isArray((value as { data?: unknown }).data)
  );
}

export function unwrapSingleService<T>(
  res: FinalResponse<T>,
  serviceName?: string,
): UnwrappedService<T> {
  if (!res?.data?.length) {
    return { found: false, status: null, payload: null, value: null };
  }

  const svc = serviceName
    ? res.data.find((entry) => entry.serviceName === serviceName)
    : res.data[0];

  if (!svc) return { found: false, status: null, payload: null, value: null };

  const payload = svc.response?.data ?? null;
  return {
    found: true,
    status:
      typeof svc.response?.status === "number" ? svc.response.status : null,
    payload,
    value: payload,
  };
}

export function unwrapSingleServiceOrDirect<T>(
  res: FinalResponse<T> | T,
  serviceName?: string,
): UnwrappedService<T> {
  if (isFinalResponse<T>(res)) {
    return unwrapSingleService(res, serviceName);
  }

  const payload = (res ?? null) as T | null;
  return {
    found: true,
    status: 200,
    payload,
    value: payload,
  };
}

export function useApiBaseUrl() {
  // Server-side: use environment variable
  // Client-side: use public proxy path
  if (import.meta.server) {
    return process.env.API_INTERNAL_BASE_URL || "/api/";
  }
  return "/api/";
}
